import { render, staticRenderFns } from "./GoodsReceiveItem.vue?vue&type=template&id=bb877e64&scoped=true"
import script from "./GoodsReceiveItem.vue?vue&type=script&lang=js"
export * from "./GoodsReceiveItem.vue?vue&type=script&lang=js"
import style0 from "./GoodsReceiveItem.vue?vue&type=style&index=0&id=bb877e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb877e64",
  null
  
)

export default component.exports